/*
 *             Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x26e8=['originalIndex','buttonView'];(function(_0x19eca7,_0x26e84d){var _0x28508c=function(_0x3f4967){while(--_0x3f4967){_0x19eca7['push'](_0x19eca7['shift']());}};_0x28508c(++_0x26e84d);}(_0x26e8,0xd0));var _0x2850=function(_0x19eca7,_0x26e84d){_0x19eca7=_0x19eca7-0x0;var _0x28508c=_0x26e8[_0x19eca7];return _0x28508c;};import{ListItemView as _0x51b04b}from'ckeditor5/src/ui';export default class H extends _0x51b04b{constructor(_0x3d06db,_0x24cafc){super(_0x3d06db),this[_0x2850('0x0')]=_0x24cafc,this[_0x2850('0x1')]=null;}}